import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';

import generationVideo from "./EduSmart_images/generationVideo.mov";
import mathVideo1 from "./EduSmart_images/math-1.mov";
import mathVideo2 from "./EduSmart_images/math-2.mov";

const EduSmart = () => {
    const mediaItems = [
        { type: 'video', src: generationVideo },
        { type: 'video', src: mathVideo1 },
        { type: 'video', src: mathVideo2 },
        { type: 'image', src: require("./EduSmart_images/1.png") },
        { type: 'image', src: require("./EduSmart_images/2.png") },
        { type: 'image', src: require("./EduSmart_images/3.png") },
        { type: 'image', src: require("./EduSmart_images/4.png") },
        { type: 'image', src: require("./EduSmart_images/5.png") },
        { type: 'image', src: require("./EduSmart_images/6.png") }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">EduSmart</h2>
        <span className="section__subtitle">State-of-the-Art Educational AI Platform</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>EduSmart is a state-of-the-art educational AI platform that revolutionizes learning through cutting-edge artificial intelligence technologies, including advanced multimodal AI, speech synthesis, and computer vision.</p>
                <br />
                <p className='redRadio__text'><strong>Advanced AI Features:</strong></p>
                <br />
                <p className='redRadio__text'>🎬 <strong>AI Video Generation Pipelines:</strong> Sophisticated pipelines that create educational videos with AI-generated avatars and animated content, providing immersive learning experiences.</p>
                <br />
                <p className='redRadio__text'>🗣️ <strong>Wave2Lip & Speech Technologies:</strong> Integration of Wave2Lip for realistic lip-sync generation combined with Text-to-Speech (TTS) and Speech-to-Text (STT) for natural communication.</p>
                <br />
                <p className='redRadio__text'>👤 <strong>Avatar Generation & Animation:</strong> AI-powered avatar creation and animation systems that generate lifelike educational presenters and interactive characters.</p>
                <br />
                <p className='redRadio__text'>🧮 <strong>AI Math Companion:</strong> Intelligent mathematical assistant powered by LLMs and VLMs that provides step-by-step problem solving and personalized tutoring.</p>
                <br />
                <p className='redRadio__text'>This groundbreaking platform combines Large Language Models (LLMs) and Vision Language Models (VLMs) to create the future of AI-driven education with unprecedented interactivity and personalization.</p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">LLMs</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">VLMs</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Wave2Lips</h3>
                <span className="skills__level"></span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">TTS/STT</h3>
                <span className="skills__level"></span>
            </div>
            </div>
        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Gradio</h3>
                <span className="skills__level"></span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">ReactJS</h3>
                <span className="skills__level"></span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Django</h3>
                <span className="skills__level"></span>
              </div>
            </div>
          
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">MySql</h3>
              <span className="skills__level"></span>
            </div>
          </div>
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default EduSmart;